export const spacings = {
  xs: '8px',
  sm: '12px',
  md: '24px',
} as const;
